import type {
  DomainRouterConnection,
  DomainRouterJsonInput,
} from './domain-router-transport';
import type {
  NotificationItem,
  NotificationPreference,
} from './notification';

export type NotificationConnection = DomainRouterConnection<NotificationItem>;
export type NotificationPreferenceConnection = DomainRouterConnection<NotificationPreference>;

export type NotificationReadAllResult = {
  updatedCount: number;
  unreadCount: number;
  updatedAt: number;
};

export const NOTIFICATIONS_QUERY_OPERATION_IDS = [
  'listNotifications',
  'getNotification',
  'listNotificationPreferences',
] as const;

export const NOTIFICATIONS_MUTATION_OPERATION_IDS = [
  'markNotificationRead',
  'markAllNotificationsRead',
  'updateNotificationPreferences',
] as const;

export type NotificationsQueryOperationId = (typeof NOTIFICATIONS_QUERY_OPERATION_IDS)[number];
export type NotificationsMutationOperationId = (typeof NOTIFICATIONS_MUTATION_OPERATION_IDS)[number];

export type NotificationsQueryArgsMap = {
  listNotifications: { input?: DomainRouterJsonInput };
  getNotification: { id: string; input?: DomainRouterJsonInput };
  listNotificationPreferences: { input?: DomainRouterJsonInput };
};

export type NotificationsQueryResultMap = {
  listNotifications: NotificationConnection;
  getNotification: NotificationItem;
  listNotificationPreferences: NotificationPreferenceConnection;
};

export type NotificationsMutationArgsMap = {
  markNotificationRead: { input: DomainRouterJsonInput };
  markAllNotificationsRead: { input: DomainRouterJsonInput };
  updateNotificationPreferences: { input: DomainRouterJsonInput };
};

export type NotificationsMutationResultMap = {
  markNotificationRead: NotificationItem;
  markAllNotificationsRead: NotificationReadAllResult;
  updateNotificationPreferences: NotificationPreference;
};
